module.exports = __webpack_public_path__ + "img/bbc_news-ob6g92htnzm45fidd2ydlx7d2olio4u1rtkv1uws0s.d6e18326.png";